/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DataImportStatus = {
    _11184809: '11184809',
    ERROR: 'ERROR',
    COMPLETE: 'COMPLETE',
    STARTED: 'STARTED',
    IMPORT_ROW_ERROR: 'IMPORT_ROW_ERROR',
    unknown_default_open_api: '11184809'
} as const;
export type DataImportStatus = typeof DataImportStatus[keyof typeof DataImportStatus];


export function instanceOfDataImportStatus(value: any): boolean {
    for (const key in DataImportStatus) {
        if (Object.prototype.hasOwnProperty.call(DataImportStatus, key)) {
            if (DataImportStatus[key as keyof typeof DataImportStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DataImportStatusFromJSON(json: any): DataImportStatus {
    return DataImportStatusFromJSONTyped(json, false);
}

export function DataImportStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataImportStatus {
    return json as DataImportStatus;
}

export function DataImportStatusToJSON(value?: DataImportStatus | null): any {
    return value as any;
}

